import type { JSX } from "react";
import { useTranslation } from "react-i18next";

import { apiErrorMessage } from "@/api/errors";
import type { components } from "@/api/schema";
import { ConfirmDialog } from "@/shared/components/ConfirmDialog";
import { toast } from "@/shared/lib/toast";

import { useDeleteUser } from "../api/use-delete-user";

type AdminUser = components["schemas"]["AdminUser"];

interface DeleteUserDialogProps {
  user: AdminUser;
  onClose: () => void;
}

export function DeleteUserDialog({ user, onClose }: DeleteUserDialogProps): JSX.Element {
  const { t } = useTranslation("users");
  const del = useDeleteUser();

  function onConfirm(): void {
    del.mutate(user.id, {
      onSuccess: () => {
        onClose();
        toast.success(t("delete.success"));
      },
      onError: (err) => toast.error(apiErrorMessage(err)),
    });
  }

  return (
    <ConfirmDialog
      title={t("delete.title", { name: user.display_name })}
      description={t("delete.description")}
      confirmLabel={t("action.delete")}
      cancelLabel={t("action.cancel")}
      isPending={del.isPending}
      onConfirm={onConfirm}
      onCancel={onClose}
    />
  );
}
